export default "__VITE_ASSET__DWtYQzeg__"